import { FC, HTMLAttributes, ReactNode } from 'react';

export interface ITableContainerProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export const TableContainer: FC<ITableContainerProps> = ({ children, className, ...props }) => (
  <div className={['w-full overflow-x-auto', className].filter(Boolean).join(' ')} {...props}>
    {children}
  </div>
);
